import { DEFAULT_LOCALE } from '@/constants';

export const mapCountryToLocale = (countryCode: string): string => {
	const cc = (countryCode || '').toUpperCase();
	const esCountries = new Set([
		'ES',
		'MX',
		'AR',
		'CO',
		'CL',
		'PE',
		'VE',
		'EC',
		'UY',
		'BO',
		'PY',
		'PA',
		'CR',
		'DO',
		'GT',
		'HN',
		'SV',
		'NI',
		'PR',
		'CU',
	]);
	if (esCountries.has(cc)) return 'es';
	if (cc === 'BR' || cc === 'PT') return 'pt';
	if (cc === 'DE' || cc === 'AT') return 'de';
	if (cc === 'FR') return 'fr';
	if (cc === 'IT') return 'it';
	if (cc === 'PL') return 'pl';
	if (cc === 'TR') return 'tr';
	if (cc === 'ID') return 'id';
	if (cc === 'IN') return 'hi';
	if (cc === 'VN') return 'vi';
	if (cc === 'TH') return 'th';
	if (cc === 'NL') return 'nl';
	return DEFAULT_LOCALE;
};
